import { defineMessages } from 'react-intl';
import { takeLatest, call, put, delay } from 'redux-saga/effects';
import { isMessage } from 'helpers/intl-fns';
import { reportError } from 'helpers/error-logging';
import { showBanner, hideBanner } from './Banner.reducer';

export const BANNER_DISPLAY_LENGTH = 5000;

export const CREATE_BANNER = 'CREATE_BANNER';

const createBanner = (message, values, { type = 'info' } = {}) => ({
  type: CREATE_BANNER,
  payload: {
    message,
    values,
    type,
  },
});

// Banners expect intl messages.  If, for some reason, a string makes it this far
// we log it as an error and pass the string through to the Banner as-is.
const messages = defineMessages({
  errorPassthrough: {
    id: 'banner.error-passthrough',
    defaultMessage: 'Error: {msg}',
  },
  infoPassthrough: {
    id: 'banner.info-passthrough',
    defaultMessage: 'Info: {msg}',
  },
});

export const createInfoBanner = (message, values = {}) => createBanner(message, values);
export const createErrorBanner = (message, values = {}) => createBanner(message, values, { type: 'error' });

export function* showThenHideBanner({ payload }) {
  const { message, type, values: { duration } = {} } = payload;
  if (isMessage(message)) {
    yield put(showBanner(payload));
  } else {
    yield call(reportError, `Banners only support intl messages - received string = "${message}"`);
    yield put(
      showBanner({
        ...payload,
        message: type === 'info' ? messages.infoPassthrough : messages.errorPassthrough,
        values: { msg: message },
      })
    );
  }
  yield delay(duration || BANNER_DISPLAY_LENGTH);
  yield put(hideBanner());
}

export function* watchBanner() {
  yield takeLatest(CREATE_BANNER, showThenHideBanner);
}
